import { isDevMode } from '@angular/core';

// NgRX
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { RouterReducerState, routerReducer } from '@ngrx/router-store';
import { networkReducer } from './network.reducer';
import { depreciationReducer, depreciationMetaReducer } from './depreciation.reducer';
import { sessionReducer } from '@core/store/reducers/session.reducer';
import { warrantyReducer } from '@core/store/reducers/warranty.reducer';
import { maintainerReducer } from '@core/store/reducers/maintainer.reducer';

// Models
import { Network } from '@core/models/network.interface';
import { Depreciation } from '@core/models/depreciation.interface';
import { Warranty } from '@core/models/warranty.interface';
import { Maintainer } from '@core/models/maintainer.interface';



export interface AppState {
  network: Network,
  depreciation: Depreciation,
  warranty: Warranty,
  maintainer: Maintainer,
  navigation: RouterReducerState,
  session: any // TO-DO: Interface...
}

export const reducers: ActionReducerMap<AppState> = {
  network: networkReducer,
  depreciation: depreciationReducer,
  warranty: warrantyReducer,
  maintainer: maintainerReducer,
  navigation: routerReducer,
  session: sessionReducer
};

export const metaReducers: MetaReducer<AppState>[] = isDevMode() ? [
   depreciationMetaReducer.debug
] : [

];
